import { DatePicker, Form, Input, Select, Space } from 'antd';
// import styles from '../index.module.less';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
// import { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import CustomModal from '@/common/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAllUsers } from 'pages/Tasks/redux/slice';
import { createFollowUp, selectFollowUpSlice } from '../redux/slice';
import { getFormattedDateToSend, getLoggedInUser } from 'utilities/helpers';
import moment from 'moment';

export default function CreateFollowUpModal({
  isOpen,
  setIsOpen,
  onAssign,
  data
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading } = useSelector(selectFollowUpSlice);
  const [team, setTeam] = useState([]);
  const isEdit = typeof isOpen === 'number';
  const { user_details } = getLoggedInUser();

  const handleClose = () => {
    isEdit ? setIsOpen(null) : setIsOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    dispatch(getAllUsers()).then((res) => {
      if (res?.payload?.success) {
        const data = res?.payload?.data;
        setTeam(data);
      }
    });
    if (isEdit && data) {
      form.setFieldsValue({
        title: data.title,
        with_whom: data.with_whom,
        assigned_to: data.assigned_to,
        followup_date: moment(data.followup_date),
        followup_notes: data.followup_notes
      });
    } else {
      form.setFieldsValue({
        assigned_to: user_details?.id
      });
    }
  }, [isEdit, isOpen]);

  const onFinish = (values) => {
    const payload = {
      ...values,
      followup_date: getFormattedDateToSend(values.followup_date)
    };
    if (isEdit) {
      payload.id = isOpen;
    }
    dispatch(createFollowUp(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[60%] md:!w-[45%] lg:!w-[40%] xl:!w-[35%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          {isEdit ? 'Edit follow-up' : 'Create follow-up'}
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="What to follow up on?"
            name="title"
            rules={[{ required: true, message: 'Title is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter follow-up title" />
          </FormItem>

          <FormItem
            label="With whom?"
            name="with_whom"
            rules={[{ required: true, message: 'This is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Search people" />
          </FormItem>

          <FormItem
            label="Who should follow up?"
            name="assigned_to"
            rules={[{ required: true, message: 'User is required' }]}
            className={styles.customLable}
          >
            <Select
              showSearch
              optionFilterProp="children"
              defaultValue="Select user"
              style={{ width: '100%' }}
              className={styles.selectField}
            >
              {team?.length
                ? team?.map((item, index) => {
                    return (
                      <option value={item?.id} key={index}>
                        {item?.first_name} {item?.last_name}
                      </option>
                    );
                  })
                : ''}
            </Select>
          </FormItem>
          {/* <div className="grid grid-cols-2 gap-4">
            <FormItem
              label="Client"
              name="client_id"
              rules={[{ required: true, message: 'Client is required' }]}
              className={styles.customLable}
            >
              <Select
                showSearch
                placeholder="All Clients"
                optionFilterProp="children"
                defaultValue="Select client"
                style={{ width: '100%' }}
                className={styles.selectField}
                // options={clients}
              ></Select>
            </FormItem>
            <FormItem
              label="Project"
              name="project_id"
              rules={[
                { required: true, message: 'Project is required' },
                {
                  validator: (_, value) =>
                    value && value === 'Select project'
                      ? Promise.reject('Project is required')
                      : Promise.resolve()
                }
              ]}
              className={styles.customLable}
            >
              <Select
                showSearch
                placeholder="All Projects"
                optionFilterProp="children"
                defaultValue="Select project"
                style={{ width: '100%' }}
                className={styles.selectField}
                // options={clients}
              ></Select>
            </FormItem>
          </div> */}

          <FormItem
            label="Follow-up date"
            rules={[{ required: true, message: 'Follow-Up date is required' }]}
            name="followup_date"
            className={styles.customLable}
          >
            <DatePicker style={{ width: '100%' }} placeholder="Select date" />
          </FormItem>

          <FormItem
            label="Notes"
            name="followup_notes"
            className={styles.customLable}
          >
            <Input.TextArea rows={3} placeholder="Add any additional context" />
          </FormItem>
        </div>
        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              loading={loading}
            >
              {isEdit ? 'Update follow-up' : 'Create Follow-up'}
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
